import React from "react"
import { graphql } from "gatsby"

import Bio from "../../components/bio"
import BlogPreview from "../../components/blog-blurb"
import Layout from "../../components/layout"
import SEO from "../../components/seo"

import { rhythm } from "../../utils/typography"

class BlogIndex extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const posts = data.allMarkdownRemark.edges

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title="Wilson Mitchell's blog"
          keywords={[`Japanese`, `travel`, `personal development`, `Korean`, `blog`, `gatsby`, `javascript`, `react`]}
        />
        <h2 style={{ marginTop: rhythm(1.0) }}>Wilson Mitchell's Blog</h2>
        <Bio />
        {posts.map(({ node }) => {
          return <BlogPreview key={node.fields.slug} {...node} />
        })}
      </Layout>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
            tags
          }
        }
      }
    }
  }
`
